// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"AddDeviceCodeModal_formContainer__3OgIe","noteText":"AddDeviceCodeModal_noteText__1FiMg"};